import React from 'react';
import { MdMenu } from 'react-icons/md';
import useActiveCondominio from '../../hooks/useActiveCondominio';
import CondomínioSelector from './CondomínioSelector';
import './PageHeader.css';

/**
 * PageHeader - Cabeçalho fixo do sistema com seletor de condomínio
 * 
 * Design:
 * - Background: branco (#ffffff)
 * - Height: 45px fixo
 * - Shadow: 0 2px 4px rgba(0,0,0,0.1) - sutil, clean
 * - Botão hamburguer + Logo "Automa" à esquerda
 * - Dropdown condomínio à direita (oculto se mono-tenant ou cargo=porteiro)
 * 
 * Props:
 * - titulo: string - Título da página (não usado no header, mantido para flexibilidade futura)
 * - cargo: string - Cargo do usuário (admin, sindico, porteiro) - controla visibilidade do seletor
 * - isMenuCollapsed: boolean - Estado do menu lateral
 * - onToggleMenu: function - Callback para alternar collapse do menu
 */
const PageHeader = ({ 
  titulo, 
  cargo = '',
  isMenuCollapsed,
  isMenuHoverExpanded = false,
  onToggleMenu
}) => {
  const { activeCondominio, setActiveCondominio, condominios } = useActiveCondominio();

  // Mostra dropdown apenas se:
  // 1. Tem mais de 1 condomínio (multi-tenant)
  // 2. E usuário é admin ou síndico (não porteiro)
  const isMultiTenant = condominios && condominios.length > 1;
  const isSingleTenant = condominios && condominios.length === 1;
  const podeVerSeletor = cargo === 'admin' || cargo === 'sindico';
  const mostrarSeletor = isMultiTenant && podeVerSeletor;
  const centralizarLogo = isSingleTenant && !mostrarSeletor;

  const handleCondomínioChange = (novoCondominioId) => {
    setActiveCondominio(novoCondominioId);
  };

  return (
    <header className="page-header">
      <div className={`page-header__container ${centralizarLogo ? 'page-header__container--single-tenant' : ''}`}>
        <div className="page-header__left">
          <button 
            className="page-header__toggle-button"
            onClick={onToggleMenu}
            title={(isMenuCollapsed && !isMenuHoverExpanded) ? "Expandir menu" : "Recolher menu"}
          >
            <MdMenu />
          </button>
          {!centralizarLogo && <div className="page-header__logo">Automa</div>}
        </div>
        
        <div className="page-header__center">
          {centralizarLogo && <div className="page-header__logo page-header__logo--centered">Automa</div>}
          {mostrarSeletor && (
            <CondomínioSelector 
              condominios={condominios}
              activeCondominio={activeCondominio}
              onChange={handleCondomínioChange}
            />
          )}
        </div>
        
        <div className="page-header__right">
        </div>
      </div>
    </header>
  );
};

export default PageHeader;
